import React from "react";
import { Nav, Popover, OverlayTrigger, Form, Button } from "react-bootstrap";
import { PersonCircle } from 'react-bootstrap-icons';
import validator from 'validator';
import api from '../../../api.js';
import OtpInput from 'react-otp-input';

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      emailError: null,
      requestMessage: null,
      show: props.isOpen,
      resetSubmitted: false,
      user: null,
      loginError: null,
      mfaReqd: false,
      otp: null,
      mfaCleared: false
    };
    
    this.env = api.getEnv();
    this.validateEmail = this.validateEmail.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
  }

  componentDidMount = () => {
    api.getMe().then((res) => {
      if (res.status === 200) {
        this.setState({ user: res.data });
      }
    }).catch((error) => {
      this.setState({ user: null });
    })
  }

  componentDidUpdate = () => {
    const props = this.props;
    if (this.state.show !== props.isOpen && props.isOpen !== undefined) {
      this.setState({ show: props.isOpen });
    }
  }

  toggleSignin = (show) => {
    // if show is null toggle
    this.setState({
      show: show !== null ? show : !this.state.show,
      submit: false,
      emailAddress: null,
      emailError: null,
      requestMessage: null,
      resetSubmitted: false,
      loginError: null
    }, () => {
    });
  }

  submit = (e) => {
    this.isLoggedIn() ? this.signout(e) : this.signin(e);
  }

  signin = (e) => {
    e.preventDefault();
    if (this.isLoggedIn()) return;
    const obj = {
      emailAddress: this.emailAddress,
      password: this.state.password
    }
    api.signin(obj)
      .then((response) => {
        if (response.status === 200) {
          const authToken = response.headers["authentication-token"];
          this.setState({ userToken: authToken });
          this.afterAuthCall()
        }
      }, (error) => {
        this.setState({ loginError: "Login unsuccessful" });
        console.log('FAILED...', error);
      });
  }

  afterAuthCall = (token) => {
    const authToken = token || this.state.userToken;
    this.setState({ loginError: null });
    api.getMe(authToken).then((res) => {
      if (res.status === 200) {
        if (res.data.mfa === "None") {
          this.setState({ user: res.data });
          this.setState({ "mfaReqd": true, "mfaCleared": true })
          this.props.loggedIn(authToken, res.data);
          this.toggleSignin(false);
        } else if (this.state.mfaCleared === true) {
          this.setState({ user: res.data });
          this.props.loggedIn(authToken, res.data);
          this.toggleSignin(false);
        } else if (res.data.emailAddress) {
          this.setState({ user: res.data });
          this.setState({ "mfaCleared": true })
          this.props.loggedIn(authToken, res.data);
          this.toggleSignin(false);
        } else {
          this.setState({ "mfaReqd": true, "mfaCleared": false })
        }
      }
    }).catch((error) => {
      this.setState({ userToken: null });
      this.afterLogout();
    })
  }

  submitTotp = (e) => {
    e.preventDefault();
    const obj = { code: this.state.otp }
    api.validateTotp(obj, this.state.userToken).then(res => {
      this.setState({ "mfaCleared": true })
      this.afterAuthCall(res.headers["authentication-token"])
    }).catch(error => {
      this.setState({ loginError: "Invalid TOTP", otp: null });
    })
  }

  isLoggedIn = () => {
    return (this.state.user !== null) && (this.state.mfaCleared || !this.state.mfaReqd)
  };

  signout = (e) => {
    e.preventDefault();
    if (!this.isLoggedIn()) {
      this.afterLogout();
      return;
    } else {
      api.deleteCurrent().then((res) => {
        if (res.status === 204) {
          setTimeout(() => {
            this.afterLogout();
          }, 1000);
        }
      })
    }
  }

  afterLogout = () => {
    this.props.loggedOut();
    this.setState({ user: null, show: false, mfaReqd: false, mfaCleared: false });
    this.toggleSignin(false);
  }

  validateEmail = (e) => {
    var email = e.target.value;
    if (!validator.isEmail(email)) {
      this.setState({ emailError: 'Please enter valid e-mail address' });
    } else {
      this.emailAddress = email;
      this.setState({
        emailError: null
      });
    }
  }

  updatePassword = (e) => {
    this.setState({ password: e.target.value });
  }

  resetPassword = (e) => {
    if (this.state.resetSubmitted === true) return;
    api.resetPassword({ emailAddress: this.emailAddress }).then((res) => {
      if (res.status === 204) {
        this.setState({ resetSubmitted: true });
        setTimeout(() => this.toggleSignin(false), 3000);
      }
    });
  }

  setOtp = (value) => {
    if (!isNaN(value)) {
      this.setState({ otp: value });
    }
  }

  render() {
    if (this.env.login === "false") {
      return '';
    }
    const popover = (
      <Popover className="pf-popover" id="popover-login" arrowProps={{ hideArrow: true }} show={this.state.show}>
        {!this.isLoggedIn() && !this.state.mfaReqd && <Popover.Title as="h3">Sign in with your e-mail address</Popover.Title>}
        {!this.state.user?.emailAddress && !this.state.mfaReqd && <Popover.Content>
          <Form onSubmit={this.submit} >
            {!this.isLoggedIn() && !this.state.mfaReqd && <Form.Group controlId="email">
              <Form.Control
                type="email"
                placeholder="E-mail"
                required name="email"
                onChange={(e) => this.validateEmail(e)}
                disabled={this.isLoggedIn()}
              />
              {this.state.emailError &&
                <span className="form-err-msg">{this.state.emailError}</span>
              }
            </Form.Group>}

            {!this.isLoggedIn() && !this.state.mfaReqd && <Form.Group controlId="password">
              <Form.Control
                type="password"
                placeholder="Password"
                name="password"
                onChange={(e) => this.updatePassword(e)}
                disabled={this.isLoggedIn()}
              />
            </Form.Group>}
            {this.state.loginError &&
              <span className="form-err-msg">{this.state.loginError}</span>
            }
            <Button variant="pf primary" type="submit">
              Sign in
            </Button>
            <Button variant="pf secondary" onClick={this.resetPassword}>
              {this.state.resetSubmitted ? "Reset Link E-mailed" : "Reset password"}
            </Button>
          </Form>

        </Popover.Content>
        }

        {this.state.user?.emailAddress && <Popover.Title as="h3">Sign out</Popover.Title>}


        {this.state.user?.emailAddress && <Popover.Content> <Form onSubmit={this.signout} >
          <Button variant="pf primary" type="submit">
            Sign out
          </Button></Form>
        </Popover.Content>}

        {this.state.mfaReqd && !this.state.mfaCleared && <Popover.Title as="h3">Enter TOTP</Popover.Title>}
        {this.state.mfaReqd && !this.state.mfaCleared && <Popover.Content>
          <Form onSubmit={this.submitTotp} >
            {<Form.Group controlId="totp" className="otp-input">
              <OtpInput
                value={this.state.otp}
                onChange={this.setOtp}
                numInputs={6}
                renderSeparator={<span>-</span>}
                renderInput={(props) => <input {...props} />}
              /> </Form.Group>}
            {this.state.loginError &&
              <span className="form-err-msg">{this.state.loginError}</span>
            }
            {this.state.otp && this.state.otp.length === 6 && <Button variant="pf primary" type="submit">
              Submit
            </Button>}

            <Button variant="pf primary" type="button" onClick={this.signout}>
              Sign in as different user
            </Button>
          </Form>
        </Popover.Content>
        }
      </Popover>
    )
    return (
      <OverlayTrigger placement="bottom-start" overlay={popover} hideArrow={true} show={this.state.show}>
        <Nav.Link className={` ${this.isLoggedIn() ? "user" : "test"}`}>
          {this.isLoggedIn() ?
            <div className="avatar" onClick={() => this.toggleSignin(null)}>
              {this.state.user.avatarUri ? <img
                className="vue-avatar--wrapper"
                src={'https://api.clay.work' + this.state.user.avatarUri}
                alt={this.state.user.name}
              /> : <span>{(this.state.user.name || this.state.user.emailAddress || "Test").substring(0, 1)}</span>}
            </div>
            : <PersonCircle size="32" onClick={() => this.toggleSignin(null)} />
          }
        </Nav.Link>
      </OverlayTrigger>
    );
  }
}

export default Login;